/* global axios */
import ApiClient from './ApiClient';

class AppointmentsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/appointments`;
  }

  index(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  show(conversationId, id) {
    return axios.get(`${this.getUrl(conversationId)}/${id}`);
  }

  create(conversationId, appointmentData) {
    return axios.post(this.getUrl(conversationId), {
      appointment: appointmentData,
    });
  }

  update(conversationId, id, appointmentData) {
    return axios.patch(`${this.getUrl(conversationId)}/${id}`, {
      appointment: appointmentData,
    });
  }

  destroy(conversationId, id) {
    return axios.delete(`${this.getUrl(conversationId)}/${id}`);
  }

  updateStatus(conversationId, id, status) {
    return axios.patch(`${this.getUrl(conversationId)}/${id}/status`, {
      status,
    });
  }
}

export default new AppointmentsAPI();
